import styled from "styled-components";
import React from "react";
import {logAction} from "../../../logging/logEvent";
import {ExpandableText} from "../../elements/ExpandableText";

const Container = styled.div`
    flex-grow: 1;
    padding-top: 8px;
`;

const PortfolioDescription = ({portfolioName, description}) => {
    const onSeeClick = (seeMore) => {
        logAction({
            type: seeMore ? `PORTFOLIO_DESCRIPTION_SEE_MORE` : `PORTFOLIO_DESCRIPTION_SEE_LESS`,
            portfolioName
        });
    };

    return <Container>
        <ExpandableText onClick={onSeeClick}
                        className="t-portfolio-description"
                        text={description}/>
    </Container>
};

export default PortfolioDescription;